"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ed2curve = require("ed2curve");
var sodium = require("libsodium-wrappers-sumo");
var ClassUtil_1 = require("../util/ClassUtil");
var InputError_1 = require("../errors/InputError");
var PublicKey = (function () {
    function PublicKey() {
        this.pub_edward = new Uint8Array([]);
        this.pub_curve = new Uint8Array([]);
    }
    PublicKey.new = function (pub_edward, pub_curve) {
        var pk = ClassUtil_1.default.new_instance(PublicKey);
        pk.pub_edward = pub_edward;
        pk.pub_curve = pub_curve;
        return pk;
    };
    PublicKey.prototype.verify = function (signature, message) {
        return sodium.crypto_sign_verify_detached(signature, message, this.pub_edward);
    };
    PublicKey.prototype.fingerprint = function () {
        return sodium.to_hex(this.pub_edward);
    };
    PublicKey.prototype.encode = function (encoder) {
        encoder.object(1);
        encoder.u8(0);
        return encoder.bytes(this.pub_edward);
    };
    PublicKey.decode = function (decoder) {
        var self = ClassUtil_1.default.new_instance(PublicKey);
        var nprops = decoder.object();
        for (var index = 0; index <= nprops - 1; index++) {
            switch (decoder.u8()) {
                case 0:
                    self.pub_edward = new Uint8Array(decoder.bytes());
                    break;
                default:
                    decoder.skip();
            }
        }
        var pub_curve = ed2curve.convertPublicKey(self.pub_edward);
        if (pub_curve) {
            self.pub_curve = pub_curve;
            return self;
        }
        throw new InputError_1.default.ConversionError('Could not convert private key with ed2curve.', 409);
    };
    return PublicKey;
}());
exports.default = PublicKey;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/keys/PublicKey.js
// module id = 9
// module chunks = 0 1